import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './index.css';
import spinner from './waitmist.gif'; // Add your spinner image path

function RegistrationForm() {
    const [step, setStep] = useState(1);
    const [employeeId, setEmployeeId] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');
    const [shopifyStoreUrl, setShopifyStoreUrl] = useState('');
    const [isEmployeeIdValidated, setIsEmployeeIdValidated] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state
    const [hashedEmployeeId, setHashedEmployeeId] = useState(''); // Store the hashed ID
    const apiKey = '44c3e9c48c9e4286bdeeb094c3d8522e';
    const headers = {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': apiKey, };
      
    const validateEmployee = 'https://hospitality-employee.azure-api.net/ssb-lookup-employee/ssbLookupIdEmployee';
    const registerEmployee = 'https://hospitality-employee.azure-api.net/ssb-registration-employee/ssbRegisterEmployee';
                              

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const storeUrl = urlParams.get('shopifyStore');
        if (storeUrl) {
            setShopifyStoreUrl(storeUrl);
        }
    }, []);

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhone = (phone) => /^\d{10}$/.test(phone);

    const validateEmployeeId = async () => {
        if (!employeeId.trim()) {
            setError('Please enter an Employee ID.');
            return;
        }
        
        setLoading(true); // Start loading
        try {
            // console.log('Calling validateEmployee endpoint:', validateEmployee, { employeeId }, headers); // Debug log
            const response = await axios.post(validateEmployee, { employeeId }, { headers });
            const responseBody = response.data;
            console.log(responseBody)
            if (responseBody.valid && !responseBody.exists) {
                // Employee ID is valid and not yet registered
                setStep(2);
                setIsEmployeeIdValidated(true);
                setHashedEmployeeId(responseBody.hashedId);
                setError('');
            } else if (responseBody.valid && responseBody.exists) {
                // Employee ID is valid but already registered
                setError('This employee is already registered with a Shopify customer account.');
            } else if (responseBody.exists && !responseBody.valid) {
                setError('This employee is terminated or inactive and is not allowed to access the registration form.')
            } else {
                // Employee ID is invalid
                setError('Invalid Employee ID. Please check and try again.');
            }
        } catch (error) {
            console.error('Validation error:', error);
            setError('Error validating Employee ID. Please try again.');
        } finally {
            setLoading(false); // Stop loading
        }
    };

    const submitRegistration = async () => {
        if (!isValidEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        if (!isValidPhone(phone)) {
            setError('Please enter a valid 10-digit US mobile phone number (no symbols or spaces). e.g., 4155552671');
            return;
        }
        setLoading(true); // Start loading
        try {
            const response = await axios.post(
                registerEmployee,
                {
                    employeeId,
                    hashedEmployeeId,
                    firstName,
                    lastName,
                    email,
                    phone
                },
                { headers }
            );

            const responseBody = response.data;

            console.log(responseBody);

            if (responseBody?.errors && responseBody.errors.length > 0) {
                // Extract readable messages
                const errorMessages = responseBody.errors.map(err => {
                    // Try to extract actual message inside JSON string
                    try {
                        const parsed = JSON.parse(
                            err.error.match(/\[.*\]/)?.[0] || '[]'
                        );
                        return parsed[0]?.message || err.error;
                    } catch {
                        return err.error;
                    }
                });
                
                const uniqueMessages = [...new Set(errorMessages)];
                setError(uniqueMessages[0]);
                return;
            }

            if (responseBody?.success) {
                setStep(3);
            } else if (responseBody?.exists) {
                 setError(
                    'This Customer already exists in our stores. To continue, Please reach out to EPPregistration@sertasimmons.com'
                );
            } else {
                setError('Error registering the account. Please try again.');
            }

        } catch (error) {
            console.error('Registration error:', error);
            setError('Error submitting the registration. Please try again.');
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div className="registration-form">
            <div className="header">
                <img
                    src="https://cdn.shopify.com/s/files/1/0681/7726/4819/files/images.png?v=1753406314&width=400"
                    alt="ssb  Logo"
                    className="logo"
                />
                <h1>Employee Registration Form</h1>
            </div>

            <div className="stepper" aria-label="Registration steps">
                <div className={`step ${step >= 1 ? 'active' : ''}`} aria-label="Step 1: Verify Employee ID"></div>
                <div className={`step ${step >= 2 ? 'active' : ''}`} aria-label="Step 2: Enter Account Details"></div>
                <div className={`step ${step >= 3 ? 'active' : ''}`} aria-label="Step 3: Registration Complete"></div>
            </div>

            {loading && (
                <div className="loading-container">
                    <img src={spinner} alt="Loading..." className="spinner" />
                </div>
            )}

            {!loading && step === 1 && (
                <div>
                    <h2>Enter Valid Employee ID</h2>
                    <label htmlFor="employeeId">Employee ID:</label>
                    <input
                        type="text"
                        id="employeeId"
                        className="input-field"
                        value={employeeId}
                        onChange={(e) => setEmployeeId(e.target.value)}
                        placeholder="Enter your Employee ID "
                        required
                    />
                    <button className="submit-button" onClick={validateEmployeeId}>
                        Validate Employee ID
                    </button>
                    {error && <p className="error-message">{error}</p>}
                </div>
            )}

            {!loading && step === 2 && isEmployeeIdValidated && (
                <div>
                    <h2>Enter Additional Information</h2>
                    <p className="info-message">Employee ID: {employeeId.replace(/^.{0,4}/, '****')} (Validated)</p>
                    <label htmlFor="firstName">First Name:</label>
                    <input
                        type="text"
                        id="firstName"
                        className="input-field"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                    <label htmlFor="lastName">Last Name:</label>
                    <input
                        type="text"
                        id="lastName"
                        className="input-field"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        className="input-field"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <label htmlFor="phone">Mobile Phone:</label>
                    <div className="phone-input-wrapper">
                        <input
                            type="tel"
                            id="phone"
                            className="input-field"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="10-digit mobile phone number"
                            required
                        />
                        <small className="phone-helper-text"> Please use format: 10-digit mobile phone number (no symbols or spaces). e.g., 4155552671</small>
                    </div>
                    <button className="submit-button" onClick={submitRegistration}>
                        Submit Registration
                    </button>
                    {error && <p className="error-message">{error}</p>}
                    <button className="exit-button" onClick={() => window.top.location.href = shopifyStoreUrl}>
                        Cancel
                    </button>
                </div>
            )}

            {!loading && step === 3 && (
                <div>
                    <h2>Registration Complete!</h2>
                    <p>Please check your email for further instructions on how to activate your employee account.</p>
                    <button className="exit-button" onClick={() => window.top.location.href = shopifyStoreUrl}>
                        Exit
                    </button>
                </div>
            )}
        </div>
    );
}

export default RegistrationForm;
